// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2LcHc","footer":"ModalCreateQualiphyProcedure_footer__2ig-e","additionData":"ModalCreateQualiphyProcedure_additionData__1GX9n"};